import { Instance } from 'mobx-state-tree';
import { OrderDeliveryDateMetadataDtoModelBase } from './OrderDeliveryDateMetadataDtoModel.base';

/* The TypeScript type of an instance of OrderDeliveryDateMetadataDtoModel */
export interface OrderDeliveryDateMetadataDtoModelType extends Instance<typeof OrderDeliveryDateMetadataDtoModel.Type> {}

/* A graphql query fragment builders for OrderDeliveryDateMetadataDtoModel */
export { selectFromOrderDeliveryDateMetadataDto, orderDeliveryDateMetadataDtoModelPrimitives, OrderDeliveryDateMetadataDtoModelSelector } from './OrderDeliveryDateMetadataDtoModel.base';

/**
 * OrderDeliveryDateMetadataDtoModel
 */
export const OrderDeliveryDateMetadataDtoModel = OrderDeliveryDateMetadataDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
